import { store } from "@/store/store";
import { scheduled_task } from "@/shared/dtos/logs/scheduled_task";
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
    namespaced: true,
    name: "scheduled_tasksModule",
    store,
    dynamic: true
})
class scheduled_tasksModule extends VuexModule {
    public tasks: scheduled_task[] = [];

    @Action({ commit: "onSetTasks" })
    public async getScheduledTasks() {
        return await ssmHttpService.get(API.scheduledTasks, null, false);
    }

    @Action
    public async updateScheduledTask(payload: { name: string, enabled?: boolean, interval_seconds?: number }) {
        const { name, ...data } = payload;
        const res = await ssmHttpService.put(`${API.scheduledTasks}/${name}`, data);
        await this.context.dispatch("getScheduledTasks");
        return res;
    }

    @Action
    public async runTaskNow(name: string) {
        const res = await ssmHttpService.post(`${API.scheduledTasks}/${name}/run-now`, {});
        await this.context.dispatch("getScheduledTasks");
        return res;
    }

    @Mutation
    public onSetTasks(res: any[]) {
        this.tasks = res && Array.isArray(res) ? res.map((x) => new scheduled_task(x)) : [];
    }
}

export default getModule(scheduled_tasksModule);
